export default __webpack_public_path__ + "static/media/3.293b675f.mp3";